export const isDevEnvironment = window.location.hostname.includes('dev');
export const isDemoEnvironment = window.location.hostname.includes('demo');
export const isStageEnvironment = window.location.hostname.includes('stage');
export const isStageOrLocalEnvironment = isStageEnvironment || window.location.hostname.includes('localhost');
export const isProductionEnvironment = window.location.host === 'www.bytecookie.net';
